import { navbarItems } from '@/utils-v2/di/providers/navbar/common-items';

export default {
  items: [...navbarItems],
};
